import { MapPin } from "lucide-react";
import EnquiryForm from "./EnquiryForm";
import { BUSINESS } from "../lib/constants";
import Reveal from "./Reveal";

export default function EnquirySection() {
  return (
    <section className="relative overflow-hidden py-20 md:py-28">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(212,175,55,0.09),transparent_55%)]" />
      <div className="relative mx-auto grid max-w-7xl items-start gap-14 px-5 sm:px-8 lg:grid-cols-2">
        <Reveal>
          <p className="eyebrow">Book Your Celebration</p>
          <h2 className="mt-4 font-display text-3xl font-semibold leading-tight text-amber-100 sm:text-4xl lg:text-5xl">
            Tell us about your event — <span className="text-gold-grad italic">we'll craft it beautifully.</span>
          </h2>
          <p className="mt-5 max-w-lg text-sm leading-relaxed text-stone-300 sm:text-base">
            Share a few details and our team will get back to you with a plan. You can also reach us
            directly — we are happy to talk through your ideas.
          </p>
          <div className="mt-8 space-y-4">
            <a
              href={BUSINESS.phoneHref}
              data-testid="enquiry-section-call-btn"
              className="card-royal flex items-center justify-between gap-4 p-5 transition-all duration-300 hover:translate-x-1"
            >
              <div>
                <p className="text-xs uppercase tracking-[0.2em] text-stone-500">Call us on</p>
                <p className="mt-1 font-display text-2xl text-amber-100">{BUSINESS.phone}</p>
              </div>
              <span className="rounded-full border border-gold/40 px-4 py-2 text-xs font-semibold uppercase tracking-widest text-amber-300">
                Call Now
              </span>
            </a>
            <a
              href={BUSINESS.whatsappHref}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="enquiry-section-whatsapp-btn"
              className="card-royal flex items-center justify-between gap-4 p-5 transition-all duration-300 hover:translate-x-1"
            >
              <div>
                <p className="text-xs uppercase tracking-[0.2em] text-stone-500">WhatsApp us on</p>
                <p className="mt-1 font-display text-2xl text-amber-100">{BUSINESS.whatsapp}</p>
              </div>
              <span className="rounded-full border border-[#25D366]/50 px-4 py-2 text-xs font-semibold uppercase tracking-widest text-[#25D366]">
                WhatsApp
              </span>
            </a>
            <p className="flex items-center gap-2 text-sm text-stone-400">
              <MapPin className="h-4 w-4 text-gold" /> {BUSINESS.address}
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.12}>
          <div className="card-royal p-6 sm:p-8">
            <h3 className="font-display text-2xl text-amber-100">Send an Enquiry</h3>
            <p className="mt-1 text-xs text-stone-500">Saved to our booking inbox & opened in WhatsApp for a fast reply.</p>
            <div className="mt-6">
              <EnquiryForm />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
